import { Avatar, IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import BooksService from "../../Services/Books";
import { HeaderBox } from './MobileBookPage';
import i18n from '../../i18n'; 
import defaultBook from "../../Images/defaultBook.png"; 
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const MobileEBooks = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [allBooks, setAllBooks] = useState([]);
  const [totalAllBooks, setTotalAllBooks] = useState(0);
  const [bookCategories, setBookCategories] = useState<any[]>([]);

  const booksLimit = 10;

  useEffect(() => {
    BooksService.getCategoriesWithBook().then((res: any) => {
      if (res.status && res.result && res.result.items) {
        const structuredCategories = res.result.items.map((categoryItem: any) => ({
          title: categoryItem.name,
          id: categoryItem.id,
          totalRecords: categoryItem.totalBooks,
          books: categoryItem.books?.slice(0, booksLimit).map((book: any) => ({
            title: book.name,
            img: book.bookThumbPath,
            id: book.id,
            slug: book.slug,
          }))
        }));
        setBookCategories(structuredCategories);
      } else {
        console.warn("No category data found or API status is not true.");
      }
    }).catch((error: any) => {
      console.error("Error fetching categories with books:", error);
    });
  }, [i18n.language]);

  useEffect(() => {
    BooksService.getBooks(
      0,
      booksLimit,
      false,
      "",
      "",
      "",
      "3", 
      "",
      window.location.pathname === "/books/special" ? true : false
    ).then((res: any) => {
      if (res.status) {
        setAllBooks(res.result.items?.map((item: any) => ({
          title: item.name,
          img: item.bookThumbPath,
          id: item.id,
          slug: item.slug,
        })));
        setTotalAllBooks(res.result.totalRecords);
      }
    }).catch((error: any) => {
      console.error("Error fetching all books:", error);
    });
  }, [i18n.language]);

  // Inline BookSection component logic
  const renderBookSection = (title: any, books: { title: string; img: string; id: string; slug?: string }[], totalRecords?: number, categoryId?: string) => {
    const handleViewAllClick = () => {
      if (categoryId) {
        navigate('/books', { state: { categoryId: categoryId, categoryName: title } });
      } else {
        navigate('/books');
      }
    };

    const shouldShowTitleViewAllButton = totalRecords !== undefined && totalRecords > books.length;

    return (
      <div
        style={{
          backgroundColor: title === "All Books" ? "#FAD5A5" : "white",
          padding: 8,
          margin: 5,
          marginTop: 5,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ fontSize: '20px', color: '#C40233', fontWeight: 600, fontFamily: 'chanakyaUni', margin: 0 }}>
            {title}
          </p>
          {shouldShowTitleViewAllButton && (
            <div
              style={{
                backgroundColor: "#f97316",
                padding: '5px 10px',
                height: 30,
                borderRadius: 3,
                color: "white",
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'chanakyaUni',
                cursor: 'pointer',
                marginLeft: '10px',
                fontSize: '14px'
              }}
              onClick={handleViewAllClick}
            >
              View All {totalRecords} Books
            </div>
          )}
        </div>

        <div style={{
          display: "flex", gap: "8px", overflowX: "auto",
          marginTop: 10, paddingBottom: "10px", scrollbarWidth: "none", msOverflowStyle: "none"
        }}>
          {books?.map((book, index) => (
            <div onClick={()=> navigate(`/books/${book?.slug}`)} key={index} style={{
              backgroundColor: "white", padding: "8px",
              width: "27vw", height: "46vw", textAlign: "center",
              flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
            }}>
              <img src={book.img || defaultBook} alt={book.title} style={{
                width: "21vw", height: "30vw", objectFit: "cover"
              }}
                onError={(e) => { e.currentTarget.src = defaultBook; }}
              />
              <p style={{
                fontWeight: "bold", color: "#4b2e2e", fontSize: "14px", marginTop: "4px",
                display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word"
              }}>
                {book.title}
              </p>
            </div>
          ))}

          {shouldShowTitleViewAllButton && (
            <div
              onClick={handleViewAllClick}
              style={{
                backgroundColor: "white", padding: "8px",
                width: "27vw", height: "46vw", textAlign: "center",
                flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px',
                  textAlign: 'center',
                }}
              >
                <Avatar sx={{ bgcolor: '#f97316', width: 35, height: 35 }}>
                  <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                </Avatar>
                <Typography className='mt-2' style={{ fontSize: '14px', color: "#f97316" }}>View All</Typography>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "#F2F0EF", height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("E_books_tr")}
        </Typography>
      </HeaderBox>

      {/* All Books Section */}
      <div style={{ flexShrink: 0 }}>
        {renderBookSection("All Books", allBooks, totalAllBooks)}
      </div>

      {/* Scrollable Section for Categories */}
      <div style={{
        flexGrow: 1,
        overflowY: 'auto',
        scrollbarWidth: "none", msOverflowStyle: "none",
        paddingBottom: 60,
        WebkitOverflowScrolling: 'touch',
      }}>
        {bookCategories.map((category, index) => (
          <React.Fragment key={index}>
            {renderBookSection(category.title, category.books, category.totalRecords, category.id)}
          </React.Fragment>
        ))}
      </div>

      {/* Footer */}
      {/* <div
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "#f97316",
          position: "fixed",
          bottom: 0,
          left: 0,
          padding: 18,
        }}
      ></div> */}
    </div>
  );
};

export default MobileEBooks;